export enum HeaderMenuSpecialItems {
  PersonalArea = "header-menu_special-item_personal-area",
  Search = "header-menu_special-item_search",
  LocaleSelector = "header-menu_special-item_locale-selector",
}

export interface StoreLocatorSpecialItemLabels {
  "header-menu-store-locator-title": string;
}

export interface SearchSpecialItemLabels {
  "header-menu-search-title": string;
  "header-menu-search-placeholder": string;
  "header-menu-search-submit": string;
}

export interface LocaleSelectorSpecialItemLabels {
  "header-menu-locale-selector-title": string;
  "header-menu-locale-selector-country": string;
  "header-menu-locale-selector-language": string;
  "header-menu-locale-selector-submit": string;
}

export interface PersonalAreaSpecialItemLabels {
  // Unauthenticated
  "header-menu-personal-area-login-title": string;
  "header-menu-personal-area-login-body": string;
  "header-menu-personal-area-login-cta": string;
  "header-menu-personal-area-signup-title": string;
  "header-menu-personal-area-signup-body": string;
  "header-menu-personal-area-signup-cta": string;
  // Authenticated
  "header-menu-personal-area-authenticated-title": string;
  "header-menu-personal-area-authenticated-greeting": string;
  "header-menu-personal-area-authenticated-body": string;
  "header-menu-personal-area-logout-cta": string;
  "header-menu-personal-area-profile-card-title": string;
  "header-menu-personal-area-profile-card-body": string;
  "header-menu-personal-area-profile-card-cta": string;
  "header-menu-personal-area-agenda-card-title": string;
  "header-menu-personal-area-agenda-card-body": string;
  "header-menu-personal-area-agenda-card-cta": string;
}

export type HeaderMenuLabels = LocaleSelectorSpecialItemLabels &
  SearchSpecialItemLabels &
  StoreLocatorSpecialItemLabels &
  PersonalAreaSpecialItemLabels;
